import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { apiSlice } from "../api/ApiService";
import patientProfileDetailsReducer from "../features/header-component/services/PatientProfileDetailsSlice";
import adminAuthReducer from "../auth/admin-auth/AdminAuthSlice";
import patientAuthReducer from "../auth/patient-auth/PatientAuthSlice";
import adminMasterDataReducer from "../features/header-component/services/AdminMasterDataSlice";
import patientMasterDataReducer from "../features/header-component/services/PatientMasterDataSlice";
import adminTabsDataReducer from "../pages/admin-dashboard/services/AdminTabsDataSlice";
import patientOnboardingReducer from "../pages/opt-in-opt-out/services/PatientStatusSlice";
import patientUserPreferenceReducer from "../features/header-component/services/PatientUserPreferenceDataSlice";
import patientUltrasoundReducer from "../pages/patient-dashboard/services/GetUltrasoundImagesDataSlice";
import imageThemesReducer from "../features/baby-size-image-widget/services/BabySizeImageDataSlice";
import learningContentReducer from "../features/view-learning-content/services/LearningContentDataSlice";
import carePlanUIReducer from "../pages/V2Pages/my-care-plan-page/services/carePlanUISlice";

// Configure persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["patientAuth"], // Only persist the patientAuth reducer
};

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  adminAuth: adminAuthReducer,
  patientAuth: patientAuthReducer,
  patientProfileDetails: patientProfileDetailsReducer,
  adminMasterData: adminMasterDataReducer,
  adminTabs: adminTabsDataReducer,
  patientOnboardingStatus: patientOnboardingReducer,
  patientMasterData: patientMasterDataReducer,
  patientPreferences: patientUserPreferenceReducer,
  patientUltraSoundData: patientUltrasoundReducer,
  babySizeImageThemes: imageThemesReducer,
  learningContent: learningContentReducer,
  carePlanUI: carePlanUIReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiSlice.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
